// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/files.css
 ** module id = 1618
 ** module chunks = 0
 **/